module.exports = __webpack_public_path__ + "img/file.67cc137d.svg";